export default __webpack_public_path__ + "static/assets/im_feedpoint_list.2ff86eb5afe8f5b9cfdd0609bf96fd64.png";